export default __webpack_public_path__ + "images/suivi.6cbea356.webp";